import React, { useEffect, useState } from 'react';
import { Redirect, Route } from 'react-router-dom';
import {
  IonApp,
  IonIcon,
  IonLabel,
  IonRouterOutlet,
  IonTabBar,
  IonTabButton,
  IonTabs
} from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';
import { square } from 'ionicons/icons';
import Surveys from './pages/Surveys';
import About from './pages/About';
import HowToUse from './pages/HowToUse';
import { NewDiaryTab } from './pages/NewDiaryTab';
import DiaryAdminTab from './pages/DiaryAdminTab';

/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';

/* Theme variables */
import './theme/variables.css';
import { useAuth0 } from "@auth0/auth0-react";
import { Admin, Diary } from './assets/DataStructures';
import Axios from 'axios';
import { firebase } from './assets/firebase'
import { Plugins, PushNotificationToken, Capacitor } from '@capacitor/core';
import { URLS } from './assets/URLS';
import { faTasks, faInfo, faPlane, faLifeRing } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useHistory } from 'react-router-dom';
import Modal from '@material-ui/core/Modal';
import { Typography } from '@material-ui/core';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import useStyles from './assets/cssClasses';
import { isPlatform } from '@ionic/react';
const { PushNotifications, Storage, Network, App: CapApp } = Plugins;

interface dbProps {
  onId: Function,
}

const admin_build = true;

const AppUrlListener: React.FC<dbProps> = (props) => {
  let history = useHistory();
  useEffect(() => {
    CapApp.addListener('appUrlOpen', (data: any) => {
      var slug = data.url.split('.com').pop();
      if (slug) {
        
        const path = slug.split('?')[0];
        const has_vars = slug.split('?').length
        if(has_vars){
          if(path === '/tab1'){
            //alert(decodeURIComponent(data.url));
            var url = new URL(decodeURIComponent(data.url));
            var duid = url.searchParams.get("duid")
            //alert(duid);
            props.onId(duid?duid:'');
          }
        }
        history.push(path);
      }
      // If no match, do nothing - let regular routing
      // logic take over
    });
  });
  
  return null;
};

const App: React.FC = () => {

  const [database, setDB] = useState<firebase.database.Database | null>(null);
  const [token, setToken] = useState<string>('');
  const [diary_ids, setDiaryIDs] = useState<Array<string>>([]);
  const [connected, setConnected] = useState<Boolean>(true);
  const [isIOS, setIsIOS] = useState<Boolean>(false);
  const { user, isAuthenticated } = useAuth0();
  const [admin, setAdmin] = useState<Admin>(new Admin('', false));

  useEffect(() => {
    //alert(getPlatforms())

    var db = firebase.database();

    setDB(db);

    PushNotifications.requestPermission().then(result => {
      if (result.granted) {
        //alert('granted')
        PushNotifications.register();
      } else {
        //alert('not granted')
        PushNotifications.register();
      }
    });

    PushNotifications.addListener('registration',
      (token: PushNotificationToken) => {
        setToken(token.value);
      }
    );

    // Some issue with our setup and push will not work
    PushNotifications.addListener('registrationError',
      (error: any) => {
        console.log('Error on registration: ' + JSON.stringify(error));
      }
    );
    // Show us the notification payload if the app is open on our device

    onNewId('');
    
    let network_stat_handler = Network.addListener('networkStatusChange', (status) => {
      console.log("Network status changed" + JSON.stringify(status));
      setConnected(status.connected);
    });

    console.log(network_stat_handler);

    //obtain token with passing all the DUIDs
    //login with custom token

    if(isPlatform('ios')){
      setIsIOS(true);
    }
    if(isPlatform('ios')){
      window.location.assign("https://apps.apple.com/bg/app/diary-survey-manager/id1549699764");
    }
    if(isPlatform('android')){
      window.location.assign("https://play.google.com/store/apps/details?id=com.brightmr.dsm");
    }
  }, []);



  

  useEffect(() => {
    console.log('token set to: ' + token);

  }, [token])

  useEffect(() => {

    onNewId('');

  }, [ database])

  
  useEffect(() => {
    if (user && isAuthenticated) {
      Axios.get(URLS.admin, { params: { 'email': user.email } }).then(function (response) {
        if (response.data.stat === 'OK') {
          setAdmin(new Admin(user.email, true))
        }
      })
    }
  }, [user, isAuthenticated])


  const onNewId = (diary_id: string) => {
    console.log("ON NEW ID CALLED")
    var ids: Array<any> = [];
    var ids_cleared: Array<any> | undefined = [];
    var all_promises: Array<any> = [];

    Axios.get(URLS.user+'/'+diary_id).then(function (response) {

      if(response.data){
        console.log("FINE");
      }else{
        alert("Invald ID");
        return null
      }
    })


    Storage.get({ key: 'diary_ids' }).then(res => {
      //alert(JSON.stringify(res.value));
      ids = (res.value?res.value.split(','):[]).filter((el)=> {return el !== ''});
      ids_cleared = (res.value?res.value.split(','):[]).filter((el)=> {return el !== ''});
      
      if(diary_id!==''){
        ids.push(diary_id)
        ids_cleared.push(diary_id);
      }


    

    }).then(
      () => {
        var ids_string = ids_cleared?.join(',');
        console.log(JSON.stringify({clean_ids: ids_string}));
        Storage.set({ key: 'diary_ids', value: ids_string ? ids_string : '' });
        setDiaryIDs(ids_cleared ? ids_cleared : []);
      }
    )


    
  }
  //Surveys - <i class=“fas fa-tasks”></i>
  //About - <i class=“fas fa-info”></i>
  //How to Use - <i class=“fas fa-life-ring”></i>
  //It seems that you’re not connected to Internet right now.  This app needs an Internet connection to operate properly. - <i class=“fas fa-plane”></i>
  const classes = useStyles();
  return (
    <IonApp>
      <Modal
        open={connected === false}
        onClose={() => { }}

      >
        <Card className={classes.grey_card}>
          <CardContent>
          <FontAwesomeIcon icon={faPlane} size="10x" />
          <Typography>It seems that you’re not connected to Internet right now.  This app needs an Internet connection to operate properly.</Typography>
          </CardContent>
        </Card>
          
      
      </Modal>
      <IonReactRouter>
        <AppUrlListener onId={onNewId}></AppUrlListener>
        <IonTabs>
          <IonRouterOutlet>
             
              <Route path="/tab1" render={(props) => (Capacitor.isNative? <Surveys {...props} db={database} on_id_add={onNewId} ids={diary_ids} admin={admin} ios={isIOS} on_new_token={setToken} token={token}/>: <HowToUse  ios={isIOS}/>)} exact={true} />
              <Route path="/tab2" render={(props) => (<NewDiaryTab   diary={new Diary()} type="ADD" ids={diary_ids} id={null} admin={admin}  ios={isIOS}/>)} exact={true} />
              <Route path="/tab3" render={(props) => (<DiaryAdminTab  db={database} admin={admin} ids={diary_ids} ios={isIOS}/>)} exact={true} />

            <Route path="/about" render={(props) => (<About  ios={isIOS}/>)} exact={true} />
            <Route path="/howto" render={(props) => (<HowToUse  ios={isIOS}/>)} exact={true} />
            <Route path="/" render={() => <Redirect to={admin_build?'/howto':'tab2'} />} exact={true} />
          </IonRouterOutlet>



          <IonTabBar slot="bottom">
            {Capacitor.isNative && !admin_build &&
              <IonTabButton tab="tab1" href="/tab1">
                <FontAwesomeIcon icon={faTasks} size="3x" />
                <IonLabel>Surveys</IonLabel>
              </IonTabButton>
            }

            {!Capacitor.isNative && isAuthenticated.valueOf() &&
              <IonTabButton tab="tab2" href="/tab2">
                <IonIcon icon={square} />
                <IonLabel>New Diary</IonLabel>
              </IonTabButton>
            }

            {!Capacitor.isNative && isAuthenticated.valueOf() &&
              <IonTabButton tab="tab3" href="/tab3">
                <IonIcon icon={square} />
                <IonLabel>Diary Admin</IonLabel>
              </IonTabButton>
            }

            <IonTabButton tab="tab4" href="/about">
              <FontAwesomeIcon icon={faInfo} size="3x" />
              <IonLabel>About</IonLabel>
            </IonTabButton>

            <IonTabButton tab="tab5" href="/howto">
              <FontAwesomeIcon icon={faLifeRing} size="3x" />
              <IonLabel>How To Use</IonLabel>
            </IonTabButton>

          </IonTabBar>
        </IonTabs>
      </IonReactRouter>
    </IonApp>
  )
};

export default App;
